import { EllipsedText, FlexColumn, LabeledData, MaterialIcon, useMoment } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { Journey } from '../../types/journey';

type Props = {
  journey: Journey;
};

function JourneyCardBody({ journey }: Props) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();

  return (
    <FlexColumn
      gap={theme.sizing.scale300}
      classNames={css({
        padding: `${theme.sizing.scale300} ${theme.sizing.scale500}`,
        height: '116px',
        boxSizing: 'border-box',
      })}
    >
      <LabeledData
        verticalAlign="center"
        label={
          <MaterialIcon
            name="pin_drop"
            size="compact"
            color={theme.colors.contentSecondary}
          />
        }
        content={
          <EllipsedText
            maxLines={2}
            style={{ color: theme.colors.contentSecondary, ...theme.typography.ParagraphSmall }}
          >
            {journey.destinationAddress || ''}
          </EllipsedText>
        }
      />
      <LabeledData
        verticalAlign="center"
        label={
          <MaterialIcon
            name="date_range"
            size="compact"
            color={theme.colors.contentSecondary}
          />
        }
        content={`${formatDateFromTs(journey.startDate)} - ${formatDateFromTs(journey.endDate)}`}
      />
      <LabeledData
        verticalAlign="center"
        label={
          <MaterialIcon
            name="moving"
            size="compact"
            color={theme.colors.contentSecondary}
          />
        }
        content={`${journey.distance} km`}
      />
    </FlexColumn>
  );
}

export default memo(JourneyCardBody);
